/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorJoinLogDto } from '../../models/vendor-join-log-dto';

export interface VendorWorkspaceJoinLogControllerCancelJoinRequest$Params {

/**
 * 가입 요청 ID
 */
  id: string;
}

export function vendorWorkspaceJoinLogControllerCancelJoinRequest(http: HttpClient, rootUrl: string, params: VendorWorkspaceJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, vendorWorkspaceJoinLogControllerCancelJoinRequest.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorJoinLogDto>;
    })
  );
}

vendorWorkspaceJoinLogControllerCancelJoinRequest.PATH = '/api/vendorJoinLog/join/{id}/cancel';
